<template>
  <div>
    <BaseFrame :saveText='isShowKeep' submitText='提交' :logText="$route.params.id? '操作日志':''"
     :infosArr='titleInfo'
      :idText='idText'
      :id='id'
      :able='able'
      @save='handleSave'
      @submit='calculateRate'
      @hanldeLog='getRecord'
      @clear="clearAll"
      :logData='records'
      :printText='printText'
      @print='handlePrint'
      >
      <div slot="content">
        <div>
          <LinkQR006 ref="LinkQR006"/>
          <div class='cardContainer'>
            <lk-card title='基础商品信息'>
              <lk-form  :label-width='134' label-position="right">
                <lk-row :gutter='16'>
                  <lk-col span='7'>

                    <lk-form-item label="商品类型:" prop='typeId' class='ivu-form-item-required'>
                      <goodsTypeCascader
                        v-if="able"
                        v-model='typeId'
                        @on-change='handleType'
                        placeholder="请选择，一旦保存将无法修改"
                        :disabled='editDisabled'
                        :isInStore='true'
                      ></goodsTypeCascader>
                      <span v-else>{{typeName}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </lk-card>
          </div>
          <div v-if='ready'>

          <Drug  v-if='goodsType===1' v-model="info.goodsBaseVO.goodsBase" :able='able' :baseData='baseData' @handleExist='handleExist' ref="baseInfo" :isInStore='true' @import='handleTempImport' @setMnemonicCode='setMnemonicCode'  :isImport='isImport'></Drug>
          <Equipment v-if='goodsType===2' v-model="info.goodsBaseVO.goodsBase" :able='able' :baseData='baseData' @handleExist='handleExist' ref="baseInfo" :isInStore='true' @import='handleTempImport' @setMnemonicCode='setMnemonicCode' :isImport='isImport'></Equipment>
          <Decoction v-if='goodsType===3' v-model="info.goodsBaseVO.goodsBase" :able='able' :baseData='baseData' @handleExist='handleExist' ref="baseInfo" :isInStore='true' @import='handleTempImport' @setMnemonicCode='setMnemonicCode' :isImport='isImport'></Decoction>
          <Others v-if='![1,2,3].includes(goodsType)' :type='typeId' v-model="info.goodsBaseVO.goodsBase" :able='able' :baseData='baseData' @handleExist='handleExist' ref="baseInfo" :isInStore='true' @import='handleTempImport' @setMnemonicCode='setMnemonicCode' :isImport='isImport'></Others>

          <StoreDrug  v-if='info.goodsStore&&(goodsType===1)' v-model="info.goodsStore" :able='able' :baseData='baseData' @handleExist='handleExist' ref="storeInfo" :isInStore='true' ></StoreDrug>
          <StoreEquipment v-if='goodsType===2&&info.goodsStore' v-model="info.goodsStore" :able='able' :baseData='baseData' @handleExist='handleExist' ref="storeInfo" :isInStore='true'></StoreEquipment>
          <StoreDecoction v-if='goodsType===3&&info.goodsStore' v-model="info.goodsStore" :able='able' :baseData='baseData' @handleExist='handleExist' ref="storeInfo" :isInStore='true'></StoreDecoction>
          <StoreOthers v-if='![1,2,3].includes(goodsType)&&info.goodsStore' v-model="info.goodsStore" :able='able' :baseData='baseData' @handleExist='handleExist' ref="storeInfo" :isInStore='true'></StoreOthers>
          </div>

        </div>
      </div>
    </BaseFrame>

      <DTPModal v-model.trim="clearModal" content='重置将取消当前所做更改。' @confirm='reset' type='alert'></DTPModal>
        <DTPModal
          v-model.trim="validateModal"
          @confirm="validateModalOk"
          @handleCancel="reset"
          :confirmText="this.approvalStatus === 2?'查看':'编辑'"
          :content='validateContentText'
          type='alert'
        >
        </DTPModal>
        <DTPModal
          v-model.trim="importModal"
          @confirm="handleImport"
          @handleCancel="reset"
          :content='"该药品已存在是否进行引用?"'
          type='alert'
        >

        </DTPModal>

        <DTPModal
        v-model="disableGoodsModal"
        content='该商品目前为禁用状态，无法引用'
        @confirm='reset'
        :noCancel='true'
        type='alert'
      ></DTPModal>
<DTPModal v-model.trim="typeModal" @handleCancel='typeId=goodsType'  content='切换商品类型将清空商品信息，是否确认此操作？' @confirm='confirmChangeType'></DTPModal>
        <lk-modal
          v-model="show"
          title="首营商品修改"
          @on-ok="handleSubmit"
          @on-cancel="handleCancel"
        >
          <div class="remark">
            <div class="remark-title">修改备注:</div>
            <lk-input placeholder="请输入修改原因" v-model="info.remark" :maxlength='200'></lk-input>
          </div>
          <div class="attachment-cont">
            <div class="remark-title">申请附件:</div>
            <Attachment
              :uploadInfo='uploadInfo'
              @attachmentConfirm='attachmentConfirm'
              @attachmentCancel="handleCancel"
            ></Attachment>
          </div>
        </lk-modal>
        <lk-modal
          title="提示"
          v-model="showAlert"
          :footer-hide='true'
          width="400"
          :closable='false'
          :mask-closable='false'>
            <div style="display:flex;">
                <span :class="{'blueIcon':isWarn, 'warnIcon':!isWarn, 'iconfont':true}">&#xe613;</span> &nbsp;
                <h6 style="margin-top: 7px;font-size: 12px;">{{ isWarn ? warnTitle : alertTitle}}</h6>
            </div>
            <div style="display:flex">
              <span class="reason">{{ isWarn ? warnContent : `您可以在${endTime}修改销项税率，或联系管理员。`}}</span>
            </div>
            <div class="bottomButton" style="margin-top: 20px;>*{margin-right: 16px}" :style="{marginLeft: `${marginLeft}px`}">
                <lk-button type='primary' v-if="isWarn" @click="showAttachment">确认</lk-button>
                <lk-button @click="showAlert=false">{{isWarn ? '取消' : '关闭'}}</lk-button>
            </div>
        </lk-modal>
  </div>
</template>

<script>
import Attachment from '../../../components/purchase/Attachment';
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import Drug from '../../../components/goods/baseGoods/Drug.vue';
import Decoction from '../../../components/goods/baseGoods/Decoction.vue';
import Equipment from '../../../components/goods/baseGoods/Equipment.vue';
import Others from '../../../components/goods/baseGoods/Others.vue';
import StoreDrug from '../../../components/goods/storeGoods/StoreDrug.vue';
import StoreDecoction from '../../../components/goods/storeGoods/StoreDecoction.vue';
import StoreEquipment from '../../../components/goods/storeGoods/StoreEquipment.vue';
import StoreOthers from '../../../components/goods/storeGoods/StoreOthers.vue';
import DTPModal from '../../../components/DTPModal.vue';
import goods from '../../../services/goods';
import supplier from '../../../services/supplier';
import inventory from '../../../services/inventory';
import utils from '../../../libs/utils';
import permission from '../../../mixins/permission';
import goodsMixins from '../../../mixins/goodsMixins';
import goodsTypeCascader from '../../../components/goodsTypeCascader.vue';

import mapState from '../../../mixins/mapState'; // 鉴权
import LinkQR006 from '../../../components/print/LinkQR006';

export default {
  name: 'GoodsStore',
  mixins: [mapState, goodsMixins, permission],
  components: {
    BaseFrame,
    DTPModal,
    Equipment,
    goodsTypeCascader,
    Drug,
    Decoction,
    Others,
    StoreDrug,
    StoreEquipment,
    StoreDecoction,
    StoreOthers,
    LinkQR006,
    Attachment,
  },
  computed: {
    marginLeft() {
      return this.isWarn ? 220 : 300;
    },
    isShowKeep() {
      return this.info.goodsStore.approvalStatus && this.info.goodsStore.approvalStatus !== 1 ? '' : '保存';
    },
    validateContentText() {
      let res = '';
      if (this.approvalStatus === 2) {
        res = '此商品在首营商品列表中已存在，正在审批中，是否前往查看？';
      } else {
        res = '此商品在首营商品列表中已存在，是否前往编辑?';
      }
      return res;
    },
    isBeijing() {
      return [7, 3].indexOf(this.$store.state.storeInfo.id) >= 0;
    },
  },
  data() {
    return {
      warnTitle: '正在设置销项税率修改为3%',
      warnContent: '如产生3%税率销售订单，系统将禁止修改销项税率36个月，是否确认提交？',
      alertTitle: '该商品3%销项税率生效未满36个月，不可修改销项税率！',
      isWarn: false,
      showAlert: false,
      oldOutputTaxRate: 0,
      endTime: '',
      timeContent: '',
      printText: '',
      goodsType: null,
      // tempType: null,
      typeModal: false,
      records: [],
      isImport: false,
      canWatch: false,
      // disableDtp: true,
      approvalStatus: null,
      // disableLoading: false,
      validateModal: false,
      importModal: false,
      disableGoodsModal: false,
      tempData: null,
      // infos: {},
      exsitId: '',
      editDisabled: false,
      idText: '',
      // saveLoading: false,
      id: '',
      titleInfo: [],
      clearModal: false,
      existsModal: false,
      typeId: null,
      ready: false,
      able: true,
      show: false, // 添加附件的modal
      uploadInfo: [
        {
          appendixName: '',
          appendixUrl: '',
        },
      ], // 审批单附件
      info: {
        goodsBaseVO: {

          goodsBase: {
            approvalNumber: '',
            approvedDrugNames: '',
            goodsName: '',
            specifications: '',


          },
        },
        goodsStore: {
          approvalStatus: null,
        },
        remark: '',
        bizExtraVos: [],
      },
      typeIdValidate: {
        typeId: [{
          required: true, message: '请选择类型', trigger: 'change', type: 'number',
        }],
      },
      // indicationTree: null,
      baseData: {
        dosageFormArr: [],
        drugMiniPackageUnitArr: [],
        storageConditionsArr: [],
        qualityOfDrugsTypeArr: [],
        preparationUnitArr: [],
        decoctionBucketArr: [],
        approvalNumberTypeArr: [],
        locations: [],
        frequencyArr: [],
        usageArr: [],
        indicationTree: null,
        taxRateList: this.$store.state.publicParams.taxRateList,
        label: {
          gspArr: [],
          bizArr: [],
          prodArr: [],
          otherArr: [],

        },
      },
    };
  },
  watch: {
    info: {
      handler() {
        setTimeout(() => {
          this.canWatch = this.ready;// 处理数据载入watch问题
        }, 100);
        if (this.canWatch) {
          this.$refs.baseInfo.firstCheck();
          this.$store.commit('setLeaveModal', true);
        }
      },
      deep: true,
    },
    $route() {
      this.init(1);
    },
  },
  methods: {

    handlePrint() {
      this.$refs.LinkQR006.handlePrint(this.$route.params.id);
    },
    clearAll() {
      this.clearModal = true;
    },
    handleType() {
      this.canWatch = false;

      this.typeModal = true;
    },
    confirmChangeType() {
      this.init(this.typeId);
      this.typeModal = false;
    },
    setMnemonicCode(name) {
      this.$store.commit('setDisableLoading', true);

      name && supplier.mnemonicCode({ name }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.$set(this.info.goodsStore, 'mnemonicCode', data);
          // this.info.goodsStore.mnemonicCode = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    reset() {
      if (this.$route.params.id) {
        this.init(this.typeId);
      } else {
        // this.init(this.typeId);
        this.isImport = false;
        this.info = {
          goodsBaseVO: { goodsBase: {} },
          goodsStore: {},
          // goodsStore: {},
        };
      }
      this.clearModal = false;

      this.validateModal = false;
      this.importModal = false;
      this.disableGoodsModal = false;
      this.$nextTick(() => {
        this.$store.commit('setLeaveModal', false);
      });
    },
    formatData(data) {
      const res = utils.deepClone(data);
      if (this.typeId === 1) {
        const { result, typeStr } = this.handleGoodsApprovalType(this.approvalNumberTypeArr, res.goodsBase.approvalNumber);
        res.goodsBase.approvalNumber = result;
        res.goodsBase.approvalNumberType = typeStr;
      }
      if (isNaN(Number.parseFloat(data.goodsBase.minTemp))) {
        res.goodsBase.minTemp = null;
      } else {
        res.goodsBase.minTemp = Number.parseFloat(data.goodsBase.minTemp);
      }
      if (isNaN(Number.parseFloat(data.goodsBase.maxTemp))) {
        res.goodsBase.maxTemp = null;
      } else {
        res.goodsBase.maxTemp = Number.parseFloat(data.goodsBase.maxTemp);
      }

      // res.goodsBase.maxTemp = Number.parseFloat(data.goodsBase.maxTemp);
      return res;
    },
    handleTempImport(data) {
      const {
        approvalNumber,
        specifications,
        approvedDrugNames,
        countryOfOrigin,
        manufacturer,
        type,
        dosageForm,
        storageConditions,
      } = data.goodsBase;
      const obj = {
        approvalNumber,
        specifications,
        approvedDrugNames,
        countryOfOrigin,
        manufacturer,
        type,
        dosageForm,
        storageConditions,
      };
      const params = this.clearUndefined(obj);
      this.handleExist(params).then((res) => {
        if (res) {
          const result = this.formatData(data);
          this.tempData = result;
          this.importModal = true;
        }
      });
    },
    // 去除请求参数中的undefined
    clearUndefined(params) {
      const obj = utils.deepClone(params);
      const keys = Object.keys(obj);
      for (const k of keys) {
        const val = obj[k];
        if (typeof val === 'undefined' || !val) {
          delete obj[k];
        }
      }
      return obj;
    },
    handleImport() {
      this.isImport = true;
      this.formatLabel(this.tempData, true);

      this.info.goodsBaseVO = this.tempData;
      this.$nextTick(() => {
        this.$refs.baseInfo.firstCheck(true);
        this.importModal = false;
      });
    },
    formatLabel(data, setData) {
      if (setData) {
        data.goodsBase.gspIdList = data.gspIdList;
        data.goodsBase.bizIdList = data.bizIdList;
        data.goodsBase.prodIdList = data.prodIdList;
        data.goodsBase.otherIdList = data.otherIdList;
        data.goodsBase.gsps = data.gsps;
        data.goodsBase.bizs = data.bizs;
        data.goodsBase.prods = data.prods;
        data.goodsBase.others = data.others;
        if (data.goodsBase.minTemp === '') {
          data.goodsBase.minTemp = null;
        }
        if (data.goodsBase.maxTemp === '') {
          data.goodsBase.maxTemp = null;
        }
        data.goodsBase.storageConditionsStringNew = data.storageConditionsString;
        data.goodsBase.drugMiniPackageUnitString = data.drugMiniPackageUnitString;
        data.goodsBase.indicationDicString = data.indicationDicString;
        data.goodsBase.dosageFormString = data.dosageFormString;
        data.goodsBase.preparationUnitString = data.preparationUnitString;
        // data.goodsBase.equipmentIdList = data.equipmentIdList;
      } else {
        data.gspIdList = data.goodsBase.gspIdList;
        data.bizIdList = data.goodsBase.bizIdList;
        data.prodIdList = data.goodsBase.prodIdList;
        data.otherIdList = data.goodsBase.otherIdList;
        // data.equipmentIdList = data.goodsBase.equipmentIdList;
      }
    },
    handleSave() {
      const saveFunc = this.$route.params.id ? goods.updateGoodsStore : goods.insertGoodsStore;
      this.$refs.baseInfo.validateForm().then((valid) => {
        if (valid) {
          const temp = utils.deepClone(this.info);
          temp.goodsBaseVO.goodsBase.type = this.typeId;
          temp.goodsStore.locationIds = temp.goodsStore.locationIds && temp.goodsStore.locationIds.join(',');
          this.baseData.supplierArr.forEach((item) => {
            if (temp.goodsStore.supplierStoreId === item.outerPassInfo.id) {
              temp.goodsStore.supplierStoreName = item.outerPassInfo.name;
            }
          });
          delete temp.goodsBaseVO.goodsLabelList;
          delete temp.goodsBaseVO.goodsLabelIdList;
          delete temp.goodsStore.locationIdList;// 后端保留删除此项
          if (temp.goodsBaseVO.goodsBase.storageConditions === 6) {
            if (!temp.goodsBaseVO.goodsBase.otherStorageCondition) {
              this.$Message.error('请输入储存条件');
              return;
            }
          }
          if (temp.goodsBaseVO.goodsBase.storageConditions != 6) {
            temp.goodsBaseVO.goodsBase.otherStorageCondition = '';
          }
          if (temp.goodsBaseVO.goodsBase.approvalNumberType) {
            temp.goodsBaseVO.goodsBase.approvalNumber = temp.goodsBaseVO.goodsBase.approvalNumberType + temp.goodsBaseVO.goodsBase.approvalNumber;
            delete temp.goodsBaseVO.goodsBase.approvalNumberType;
          }
          this.formatLabel(temp.goodsBaseVO);
          // this.saveLoading = true;
          if (this.goodsType === 2 && this.isBeijing) { // 删除暂存的机械  udiFlag
            temp.goodsStore.udiFlag = temp.goodsBaseVO.goodsBase.udiFlag;
            if (temp.goodsBaseVO.goodsBase.hasOwnProperty('udiFlag')) {
              delete temp.goodsBaseVO.goodsBase.udiFlag;
            }
          }
          saveFunc(temp).then((res) => {
            if (res.data.status === 200) {
              // this.saveLoading = false;
              this.$Message.success('保存成功');
              this.$store.commit('setLeaveModal', false);

              this.$router.push({ name: 'storeGoodsList', params: { create: !this.$route.params.id } });
            } else {
              this.$Message.error(res.data.error);
            }
            // this.saveLoading = false;
          }).catch((err) => {
            utils.handleError(err);
          });
        } else {
          this.$Message.error('缺少必填项或信息不符合要求，请检查后再提交');
        }
      });
    },
    handleSubmit() {
      const submitFunc = goods.submitGoodsStore;
      this.$refs.baseInfo.validateForm(true).then((valid) => {
        this.$refs.storeInfo.validateForm().then((storeValid) => {
          if (valid && storeValid && utils.handleExpire(this.$refs.baseInfo.$el)) {
            const temp = utils.deepClone(this.info);

            temp.goodsBaseVO.goodsBase.type = this.typeId;
            temp.goodsStore.locationIds = temp.goodsStore.locationIds && temp.goodsStore.locationIds.join(',');
            this.formatLabel(temp.goodsBaseVO);

            this.baseData.supplierArr.forEach((item) => {
              if (temp.goodsStore.supplierStoreId === item.outerPassInfo.id) {
                temp.goodsStore.supplierStoreName = item.outerPassInfo.name;
              }
            });
            if (temp.goodsBaseVO.goodsBase.approvalNumberType) {
              temp.goodsBaseVO.goodsBase.approvalNumber = temp.goodsBaseVO.goodsBase.approvalNumberType + temp.goodsBaseVO.goodsBase.approvalNumber;
              delete temp.goodsBaseVO.goodsBase.approvalNumberType;
            }

            delete temp.goodsBaseVO.goodsLabelList;
            delete temp.goodsBaseVO.goodsLabelIdList;
            delete temp.goodsStore.locationIdList;// 后端保留删除此项
            if (temp.goodsBaseVO.goodsBase.storageConditions != 6) {
              temp.goodsBaseVO.goodsBase.otherStorageCondition = '';
            }
            if (this.uploadInfo) {
              temp.bizExtraVos = this.uploadInfo;
            }
            if (this.goodsType === 2 && this.isBeijing) { // 删除咱村的机械  udiFlag
              temp.goodsStore.udiFlag = temp.goodsBaseVO.goodsBase.udiFlag;
              if (temp.goodsBaseVO.goodsBase.hasOwnProperty('udiFlag')) {
                delete temp.goodsBaseVO.goodsBase.udiFlag;
              }
            }
            submitFunc(temp).then((res) => {
              if (res.data.status === 200) {
                // this.saveLoading = false;
                this.$Message.success('保存成功');
                this.$store.commit('setLeaveModal', false);

                this.$router.push({ name: 'storeGoodsList', params: { create: !this.$route.params.id } });
              } else {
                this.$Message.error(res.data.error);
              }
              // this.saveLoading = false;
            }).catch((err) => {
              utils.handleError(err);
            });
          } else {
            this.$Message.error('缺少必填项或信息不符合要求，请检查后再提交');
          }
        });
      });
    },
    handleCancel() {
      this.info.remark = '';
    },
    validateModalOk() {
      this.validateModal = false;
      this.$nextTick(() => {
        const params = { id: this.tempId, type: this.typeId };
        this.$store.commit('setLeaveModal', false);
        if (this.approvalStatus === 2) {
          this.$router.push({ name: 'GoodsStoreView', params });
        } else {
          this.$router.push({ name: 'GoodsStoreEdit', params });
        }
      });
    },
    handleExist(params) {
      return new Promise((resolve) => {
        params.type = this.typeId;
        this.$store.commit('setDisableLoading', true);
        // this.disableLoading = true;
        goods.storeCheckIsExist(params).then((res) => {
          if (res.data.status === 200) {
            const result = res.data.data;

            // 已经有数据，弹窗显示
            if (result) {
              const { approvalStatus } = result.goodsStore;
              this.tempId = result.goodsStore.id;
              this.approvalStatus = approvalStatus;
              this.validateModal = true;
              resolve(false);
            } else {
              resolve(true);
              this.$store.commit('setDisableLoading', true);
              goods.baseCheckIsExist(params).then((subRes) => {
                if (subRes.data.status === 200) {
                // 已经有数据，弹窗显示
                  if (subRes.data.data) {
                    const temp = this.formatData(subRes.data.data);
                    if (temp.goodsBase.minTemp != '' && temp.goodsBase.minTemp != null) {
                      temp.goodsBase.minTemp *= 1;
                    }
                    if (temp.goodsBase.maxTemp != '' && temp.goodsBase.maxTemp != null) {
                      temp.goodsBase.maxTemp *= 1;
                    }
                    this.formatLabel(temp, true);

                    this.tempData = utils.deepClone(temp);
                    // if (!this.submitLoading && !this.saveLoading) { // 处理保存后显示问题
                    this.importModal = true;
                  // }
                  }
                } else if (subRes.data.status === 42006) {
                  this.disableGoodsModal = true;
                } else {
                  this.$Message.error(subRes.data.error);
                }
              }).catch((err) => {
                utils.handleError(err);
              });
            }
          } else {
            this.$Message.error(res.data.error);
          }
        // this.disableLoading = false;
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getSupplierList() {
      return new Promise((resolve) => {
        supplier.SupplierStoreOuterList({ status: 1 }).then((res) => { // status:1 过滤掉禁用的供应商
          if (res.data.status === 200) {
            this.baseData.supplierArr = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getSelectArrs() {
      return new Promise((resolve) => {
        this.baseData.decoctionBucketArr = [];
        this.baseData.drugMiniPackageUnitArr = [];
        this.baseData.storageConditionsArr = [];
        this.baseData.qualityOfDrugsTypeArr = [];
        this.baseData.dosageFormArr = [];
        this.baseData.preparationUnitArr = [];

        this.baseData.periodAlertDaysArr = [];
        this.baseData.paymentTypeArr = [];
        this.baseData.frequencyArr = [];
        this.baseData.usageArr = [];
        this.baseData.approvalNumberTypeArr = this.approvalNumberTypeArr;


        goods.GoodsDictionary().then((res) => {
          if (res.data.status === 200) {
            res.data.data.forEach((item) => {
              switch (item.dictionaryType) {
                case 1:
                  this.baseData.dosageFormArr.push(item);
                  break;
                case 2:
                  this.baseData.decoctionBucketArr.push(item);

                  break;
                case 3:
                  this.baseData.drugMiniPackageUnitArr.push(item);

                  break;
                case 7:
                  this.baseData.paymentTypeArr.push(item);

                  break;
                case 8:
                  this.baseData.qualityOfDrugsTypeArr.push(item);

                  break;
                case 9:
                  this.baseData.storageConditionsArr.push(item);

                  break;
                case 10:
                  this.baseData.periodAlertDaysArr.push(item);
                  break;
                case 11:
                  this.baseData.preparationUnitArr.push(item);
                  break;
                case 14:
                  this.baseData.usageArr.push(item);
                  break;
                case 15:
                  this.baseData.frequencyArr.push(item);
                  break;

                default:
                  break;
              }
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getData() {
      const { id, type, status } = this.$route.params;
      goods.getGoodsStoreById({ id, type, status }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          if (this.typeId === 1) {
            const { result, typeStr } = this.handleGoodsApprovalType(this.approvalNumberTypeArr, data.goodsBaseVO.goodsBase.approvalNumber);
            data.goodsBaseVO.goodsBase.approvalNumber = result;
            data.goodsBaseVO.goodsBase.approvalNumberType = typeStr;
          }
          this.formatLabel(data.goodsBaseVO, true);
          data.goodsStore.locationIds = data.goodsStore.locationIds ? data.goodsStore.locationIds.split(',') : [];
          if (data.goodsBaseVO.goodsBase.minTemp != '' && data.goodsBaseVO.goodsBase.minTemp != null) {
            data.goodsBaseVO.goodsBase.minTemp *= 1;
          }
          if (data.goodsBaseVO.goodsBase.maxTemp != '' && data.goodsBaseVO.goodsBase.maxTemp != null) {
            data.goodsBaseVO.goodsBase.maxTemp *= 1;
          }
          this.info = utils.deepClone(data);
          this.idText = '商品ID';
          this.id = data.goodsBaseVO.goodsBase.drugSerialCode;
          if (this.goodsType === 2 && this.isBeijing) { // 器械进行赋值
            this.info.goodsBaseVO.goodsBase.udiFlag = this.info.goodsStore.udiFlag;
          }
          this.oldOutputTaxRate = this.info.goodsStore.outputTaxRate;
          this.endTime = utils.formatTime(data.goodsStore.outputTaxRateLimitTimeEnd, 'YYYY年MM月DD日');
          this.titleInfo = [
            { name: '商品通用名：', value: data.goodsBaseVO.goodsBase.approvedDrugNames },
            { name: '创建人：', value: data.goodsStore.createUserName },
            { name: '创建时间：', value: data.goodsStore.createTime ? utils.exchangeTimeToSecond(data.goodsStore.createTime) : '' },
            { name: '建档时间：', value: data.goodsStore.buildTime ? utils.exchangeTimeToSecond(data.goodsStore.buildTime) : '' },
            { name: '申请单号：', value: data.goodsStore.applyCode },
            { name: '修改人：', value: data.goodsStore.modifiedUserName },
            { name: '最后修改时间：', value: data.goodsStore.modifiedTime ? utils.exchangeTimeToSecond(data.goodsStore.modifiedTime) : '' },
          ];
        } else {
          this.$Message.error(res.data.error);
        }

        this.ready = true;
      }).catch((err) => {
        utils.handleError(err);
      });
    },


    getLocations() {
      return new Promise((resolve) => {
        inventory.getLocationData().then((res) => {
          if (res.data.status === 200) {
            this.baseData.locations = [];
            // this.baseData.locations = res.data.data.list;
            res.data.data.list.forEach((item) => {
              const result = {
                name: `${item.warehouseName}/${item.locationCode}`,
                id: item.id,
              };
              this.baseData.locations.push(result);
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getRecord() {
      this.$store.commit('setDisableLoading', true);

      goods.getStoreRecord({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.records = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    init(type) {
      this.canWatch = false;
      this.editDisabled = false;
      // this.reset();
      this.ready = false;
      this.isImport = false;
      this.titleInfo = [];
      this.id = '';
      this.idText = '';
      const baseArr = [
        this.getAllLabels(this.$route.params.type || type),
        this.getSelectArrs(),
        this.fetchListIndications(),
        this.getSupplierList(),
      ];
      (this.$route.params.type * 1 === 3 || type === 3) && baseArr.push(this.getLocations());
      Promise.all(baseArr).then(() => {
        this.able = this.$route.name !== 'GoodsStoreView';
        this.$nextTick(() => {
          // this.info.goodsStore = {};
          this.$set(this.info, 'goodsStore', {});
          this.typeId = Number.parseInt(this.$route.params.type, 0) || type;
          this.goodsType = this.typeId;
          if (this.$route.params.id) {
            this.getData();

            this.editDisabled = true;
          } else {
            this.reset();

            this.ready = true;
          }
        });
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    attachmentConfirm(val) {
      this.uploadInfo = val;
    },
    calculateRate() {
      const create = this.info.goodsStore.outputTaxRate == 3 && !this.$route.params.id;
      const update = this.info.goodsStore.outputTaxRate !== this.oldOutputTaxRate && this.info.goodsStore.outputTaxRate == 3 && this.$route.params.id && this.info.goodsStore.updateOutputTaxRateFlag == 1;
      const draft = this.info.goodsStore.outputTaxRate !== (this.info.goodsStore.effectiveOutputTaxRate || '') && this.info.goodsStore.outputTaxRate == 3 && this.$route.params.id && this.info.goodsStore.updateOutputTaxRateFlag == 1;
      const alert = this.info.goodsStore.outputTaxRate !== this.oldOutputTaxRate && this.$route.params.id && this.info.goodsStore.updateOutputTaxRateFlag == 2;
      if (create || update || draft) { // 创建时或者修改时为3%
        this.showAlert = true;
        this.isWarn = true;
      } else if (alert) {
        this.showAlert = true;
        this.isWarn = false;
      } else {
        this.isWarn = false;
        this.showAttachment();
      }
    },
    showAttachment() {
      this.showAlert = false;
      if (this.$route.params.id) {
        this.show = true;
      } else {
        this.handleSubmit();
      }
    },
  },
  mounted() {
    if (this.$route.name === 'GoodsStoreView' && this.permissionFunc('GoodsStorePrint')) {
      this.printText = '打印';
    }
    this.init(1);
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //   });
  // },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
  .storageConditions{
    display: flex;
    align-items: center;
    justify-content: space-between

  }
  .other{
    /* width: 17% */
  }
  .temperature{
    width:660px;
    display: flex;
    justify-content: flex-end
  }
  .attachment-cont {
    display: flex;
  }
  .remark {
    margin-bottom: 16px;
  }
  .remark-title {
    margin-bottom: 16px;
    padding-left: 4px;
  }
.warnIcon {
  color: orange;
  font-size: 20px;
}

.blueIcon {
  color: #1890FF;
  font-size: 20px;
}

.reason {
  margin-top:8px;
  font-size: 12px;
  margin-left: 24px;
}

.bottomButton{
    margin-left: 220px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
}

</style>
